import { AngularGooglePlaceConstantService } from './constants/index';
import { AngularGooglePlaceDirective } from './directives/index';
import { AngularGooglePlaceService } from './services/index';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
export class AngularGooglePlaceModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [AngularGooglePlaceDirective],
  providers : [ AngularGooglePlaceService, AngularGooglePlaceConstantService ],
  exports: [AngularGooglePlaceDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AngularGooglePlaceModule_tsickle_Closure_declarations() {
/** @type {?} */
AngularGooglePlaceModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AngularGooglePlaceModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
